module.exports = __webpack_public_path__ + "img/icon-lock.42850f9c.svg";